
        import 'Stat.7786930.css-module'
        export default {"stat":"stat_Stat_7786930","statFigure":"statFigure_Stat_7786930","statTitle":"statTitle_Stat_7786930","statValue":"statValue_Stat_7786930","statDesc":"statDesc_Stat_7786930","accent":"accent_Stat_7786930","primary":"primary_Stat_7786930","info":"info_Stat_7786930"}
    